import HtmlParser from 'html-react-parser';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';


function HeroModal() {
	const [modalShow, setModalShow] = React.useState(false);

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">See it in action</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://charthop.wistia.com/medias/j1aatk4i5w'
							playing
							volume={1}
							controls={false}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="page-integrations planning" ontouchstart>
            <SEO title="Headcount Planning | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Use scenarios to design headcount plans and measure the impact structural and budgetary impact of your changes. Finally - fast, easy, and flexible org design. "
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Headcount Planning | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Use scenarios to design headcount plans and measure the impact structural and budgetary impact of your changes. Finally - fast, easy, and flexible org design. " />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-planning.png`} />
                <meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Headcount Planning | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Use scenarios to design headcount plans and measure the impact structural and budgetary impact of your changes. Finally - fast, easy, and flexible org design. ." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-planning.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row py-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>Plan for anything.</h1>
                        <p className="header-p pb-1 pt-1">The first scenario planning platform that puts people first.</p>
                        <div className="splitText"><DemoFormShort source={"product-planning-demo-header"} /></div>   
						<HeroModal />                     
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one" >
						<ReactPlayer
							url="/home/05_Scenario_03_Optimized.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
                </div>
            </section>

			{/* customers */}
			<section className="customer testimonial-container backgroundGradientContainer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>

			{/* never */}
            <section className="sectionSpacing flex-centeredColumn">
            	<h2 className="text-center mt-0 sectionSpacing-Margin">Plan like never before.</h2> 
            	<div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                    <div className="svg-info-card-3col">
							<img src={'/product/org-chart/picture.svg '} alt="Visualize" />
							<h3>Plan with context</h3>
							<p>Centralize current and historic data to create informed plans, without the manual work.  </p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/visualize.svg'} alt="Put a face to the name" />
							<h3>Visualize changes</h3>
							<p>Build plans visually and understand the structural implications from the get go.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/covid-data/icon-analytics.svg'} alt="Time Saving" />
							<h3>Track impact</h3>
							<p> Measure how every change impacts people analytics metrics, operational KPIs & budget.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/transparency.svg'} alt="Transparency" />
							<h3>Streamline workflows</h3>
							<p>Create scalable processes for headcount approvals, compensation reviews & more.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/work.svg'} alt="Work" />
							<h3>Centralize changes</h3>
							<p> Iterate on plans with stakeholders and keep all discussions within the platform. </p>
						</div>                       
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/time.svg '} alt="Data Access" />
							<h3>Save hours of time</h3>
							<p> Easily consolidate plans with the click of a button, no copy and paste needed.</p>
						</div>
					</div>
				</div>
            </section>

			{/* team */}
			<section className="sectionSpacing backgroundGradientContainer">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="right"
                        title="Plan out your team"
                        link="/landings/Scenario_RemoveOpenRole.gif"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Understand the structural and budgetary impact of any change across your organization:</p>
								<div className="row pb-0 pt-0">
									<div className="col-lg-6 col-md-12">
										<p className="mb-0">								
											<li>Create and close open roles</li>
											<li>Plan departures</li>
											<li>Propose promotions</li>																		
										</p>
									</div>
									<div className="col-lg-6 col-md-12">
										<p className="mb-0">	
											<li>Restructure teams</li>
											<li>Merge teams </li>
											& so much more							
										</p>
									</div>								
								</div>
                            </React.Fragment>
                        }
                    />					
				</div>
			</section>

			{/* Collaborate */}
			<section className="sectionSpacing">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="left"
                        title="Collaborate seamlessly"
                        link="/landings/scenario-sharing.gif"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Centralize your changes and discussions in one place.</p><p> Collaborate with stakeholders all within the platform, without emailing spreadsheets and powerpoints back and forth. </p>
                            </React.Fragment>
                        }
                    />	
				</div>
			</section>

			{/* impact */}            
            <section className="sectionSpacing backgroundGradientContainer">
				<div className="contentBlock">
					<MultimedialPanel 
                        multimediaPosition="right"
                        title="Analyze impact"
                        link="/landings/scenario-impact-report.gif"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Forget manual spreadsheets filled with complex models.</p><p> Build your future team visually and understand the impact across all your KPIs. Finally align People, Finance, Recruiting and hiring managers.</p>
                            </React.Fragment>
                        }
                    />						
				</div>
			</section>

            <div className="sectionSpacing mx-0 mt-0">
						<h4 className="listTitle text-xs-left mt-0 text-sm-center">The planning platform for any plan.</h4>
						<div className="pgc1 pgc1-container">
							<div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Annual headcount plans</p>
								</div>
							</div>
                            <div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Continuous adjustments</p>
								</div>
							</div>
                            <div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Compensation plans</p>
								</div>
							</div>
							<div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Layoffs & restructures</p>
								</div>
							</div>
                            <div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Promotion plans</p>
								</div>
							</div>
							<div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>M&A integrations</p>
								</div>
							</div>
							<div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Contingency plans</p>
								</div>
							</div>
							<div className="pgc2">
								<div className="pgc3">
									<img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
									<p>Succession plans</p>
								</div>
							</div>

						</div>
						<p className="subListTitle mb-0 font-weight-bold text-center">& more</p>
					</div>

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"product-planning-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“ChartHop helped us centralize over a hundred headcount planning spreadsheets into a single platform.</br></br> We could easily monitor people’s access, progress and consolidate multiple plans with a couple of clicks.”</p><div class="authorTag"><img src="/home/quotes/quote_AlexKoykova@2x.jpg" class="testimonialAuthor" alt="Alex Koykova" /><div><p class="contactAuthor"><strong>Alex Koykova</strong> <br>Director, People Operations<br><img src="/home/brand_logos/mongodb-logo-original.svg" alt="MongoDB" class="MongoDBauthor" /></p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
